module.exports = "pegasus_template/assets/theme4/l_d.png";